import { useApp } from '../../context/AppContext';
import { Button } from '../ui/button';
import { Globe } from 'lucide-react';

export const LanguageToggle = () => {
  const { language, toggleLanguage } = useApp();
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="h-9 px-3 rounded-full hover:bg-muted transition-all duration-200 gap-2"
      data-testid="language-toggle"
    >
      <Globe className="h-4 w-4 text-muted-foreground" />
      <span className="font-medium text-sm uppercase tracking-wide">
        {language === 'ro' ? 'EN' : 'RO'}
      </span>
    </Button>
  );
};

export default LanguageToggle;
